<template lang="pug">
  .form
    h2.form-header お問い合わせ
    .form-body
      div(v-if="status === 'form'")
        div(v-if="errors.length")
          ul.errors
            li(v-for="(error, index) in errors") {{ error }}
        div(v-else)
          p.heading
            |ご相談やお問合せ・お見積り依頼は
            br
            |お気軽にご連絡ください
        .form-group
          label 会社名
          input.input(type="text" v-model="company" placeholder="株式会社〇〇〇〇")
          span.error(v-if="company !== ''") {{errors.company}}
        .form-group
          label
            |お名前
            span *
          input.input(type="text" v-model="name" placeholder="お名前をご記入ください。")
          span.error(v-if="name !== ''") {{errors.name}}
        .form-group
          label
            |メール
            span *
          input.input(type="email" name="email" v-model="email" placeholder="example@orient-sailing.com")
          span.error(v-if="email !== ''") {{errors.email}}
        .form-group
          label 電話番号
          input.input(type="number" v-model="tel" placeholder="080-0000-0000")
          span.error(v-if="tel !== ''") {{errors.tel}}
        .form-group
          label ご予算
          input.input(type="text" v-model="badget" placeholder="50万円〜")
          span.error(v-if="badget !== ''") {{errors.badget}}
        .form-group
          label
            |お問い合わせ内容
            span *
          textarea(v-model="message" placeholder="お問い合わせ内容をご記入ください。")
          span.error(v-if="message !== ''") {{errors.message}}
        .form-buttons
          button.button.button--submit(type="submit" @click="confirm()") 送信する
      div(v-else-if="status === 'confirm'")
        .form-group
          label 会社名
          p.conform {{company}}
        .form-group
          label お名前
          p.conform {{name}}
        .form-group
          label メール
          p.conform {{email}}
        .form-group
          label 電話番号
          p.conform {{tel}}
        .form-group
          label ご予算
          p.conform {{badget}}
        .form-group
          label お問い合わせ内容
          p.conform {{message}}
        .form-buttons
          button.button.button--submit(type="submit" v-bind:class="{ 'disabled': isPush}" v-bind:disabled="isPush" @click="send()") 送信する
          button.button.button--return(type="submit" @click="updateStatus('form')") 戻る
      div(v-else-if="status === 'succeeded'")
        p.message お問い合わせを受け付けました。お問い合わせいただきました内容を確認後、担当者より改めてご連絡いたします。
        .form-buttons
          button.button.button--return(type="submit" @click="close()") 戻る
      div(v-else-if="status === 'failed'")
        p.message メッセージの送信に失敗しました。恐れ入りますが、時間をおいてもう一度お試しください。
        .form-buttons
          button.button.button--return(type="submit" @click="close()") 戻る

</template>

<script>

import { vm } from "../../service/bus"
import axios from 'axios'
axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

export default{
  // props:  ['taxonomies'],
  data: function(){
    return {
      name: null,
      email:null,
      message: null,
      badget: null,
      company: null,
      tel: null,
      isActive: false,
      status: "form",
      errors: [],
      isPush : false,
    }
  },
  watch: {
  },
  created: function () {
  },
  methods: {
    updateStatus: function(status){
      this.status = status;
    },
    close: function(){
      this.name = null;
      this.email = null;
      this.message = null;
      this.tel = null;
      this.company = null;
      this.badget = null;
      this.isActive = false;
      setTimeout(() => this.status = 'form', 500);
    },
    confirm: function(){
      this.errors = [];
      if (!this.name) {
        this.errors['name'] = 'お名前をご記入ください。';
      }
      if (!this.email) {
        this.errors['email'] = 'メールアドレスをご記入ください。';
      }
      if (!this.message) {
        this.errors['message'] = 'お問い合わせ内容をご記入ください。';
      }
      // if (!this.badget) {
      //   this.errors['badget'] = 'ご予算をご記入ください。';
      // }
      // if (!this.company) {
      //   this.errors['company'] = '会社名をご記入ください。';
      // }
      // if (!this.tel) {
      //   this.errors['tel'] = '電話番号をご記入ください。';
      // }
      if (this.name && this.email && this.message) {
        this.updateStatus('confirm')
      }
    },
    send: function(){
      this.isPush = true;
      if(this.isPush){
        axios.post(`/design-base/api/v1/indices/inquiry`,{
          inquiry:{
            company: this.company,
            name: this.name,
            email: this.email,
            tel: this.tel,
            badget: this.badget,
            message: this.message,
          },
          headers: {
            'content-type': 'application/json',
          },
          timeout : 3000
        })
        .then((response) => {
          this.status = "succeeded";
          this.isPush = false;

        })
        .catch((error) => {
          console.log(error);
          this.status = "failed";
          this.isPush = false;
        })
      }
      
    },
  }
}
</script>


<style lang="scss" scoped>
@import "../../../assets/stylesheets/variables";
.form{
  width: 960px;
  margin: 180px auto 40px;
  padding: $space-xxl;
  background: #fff;
  box-shadow: 0px 0px 5px 1px rgb(0 0 0 / 10%); 
  @media only screen and( max-width: 768px){
    width: 90%;
    margin: 180px auto 40px;
    padding: $space-l;
  }
  &-header{
    margin-bottom: $space-m;
    font-size: $font-m;
    letter-spacing: 0.05rem;
    font-weight: bold;
    &:after{
      display: block;
      content: '';
      width: 50px;
      height: 3px;
      margin-top: $space-l;
      background: $bg-secondary;
    }
  }
  &-body{
    .heading{
      margin-bottom: $space-l;
      line-height: 2;
      font-size: $font-xxs;
      // font-weight: bold;
    }
    .message{
      padding: 16px 0;
      line-height: 1.5;
    }
    .conform{
      margin-top: $space-s;
      padding: 16px;
      background: #f7f7f7;
    }
  }
  &-buttons{
    display: flex;
  }
  &-group{
    margin-bottom: $space-l;
    & > .error{
      font-weight: bold;
      color: #d23f40;
      list-style: disc;
      margin-bottom: $space-xxs;
    }
  }
  label{
    color: #000;
    font-size: 14px;
    font-weight: bold;
    span{
      margin-left: $space-xxs;
      color: #d23f40;
      font-size: 15px;
    }
  }
  .input{
    height: 50px;
    margin-top: 6px;
    margin-bottom: 12px;
    line-height: 1.5;
    border: solid 1px #ccc;
    box-shadow: none;
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 14px;
    color: #555555;
    vertical-align: middle;
    background-color: #fff;
    background-image: none;
    // border-radius: 4px;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    &:focus{
      border-color: #666;
      outline: none;
    }
  }
  textarea{
    height: 100px;
    margin-top: 6px;
    margin-bottom: 12px;
    padding: 10px 12px 6px;
    color: #555555;
    line-height: 1.5;
    border: solid 1px #ccc;
    box-shadow: none;
    display: block;
    width: 100%;
    vertical-align: middle;
    background-color: #fff;
    background-image: none;
    font-size: 14px;
    // border-radius: 4px;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    &:focus{
      border-color: #666;
      outline: none;
    }
  }
  .button{
    // width: 100%;
    margin-top: 12px;
    padding: $space-s $space-m;
    border-radius: 3px;
    font-size: 16px;
    line-height: 2;
    &:first-child{
      margin-right: 3px;
    }
    &:nth-child(2){
      margin-left: 3px;
    }
    &:focus{
      outline: none;
    }
    &--submit{
      background: $bg-secondary;
      color: #fff;
      font-weight: bold;
      transition: .3s;
      &.disabled{
        opacity: .3;
        transition: .3s;
      }
    }
    &--return{
      background: #666;
      color: #fff;
      font-weight: bold;
    }
  }
}
.opened{
  bottom: 0px;
  transition: .3s;
}
</style>
